import _ from 'underscore';
import NotificationsView from 'js/views/notifications.view';
import Template from 'js/templates/notifications.navbar.hbs';
import i18n from 'l10n';
import {debounce, el, tagName, template} from "../adapters/backbone-decorators";

require('metroHint2');

const gutterSize = 5;


@el(".notifications-content")
@tagName("span")
@template(Template)
class NotificationsNavbarView extends NotificationsView {
    cachedModels = {};
    listview = '#notifications-list-view';
    rowHeight = 80 + gutterSize;

    constructor(numberOfElements) {
        super(numberOfElements);
    }

    render(cap) {
        var templateOutput = this.template({newNotifications: cap});
        this.$el.html(templateOutput);
        this.$('[data-i18n]').i18n();
        this.$('[data-i18n]').each(function () {
            if (typeof $(this).data("hint") === "string") {
                $.Metro.initAll(this);
            }
        });

        this.redrawNotifications(cap);
    }

    renderRest() {
        if (!_.isEmpty(this.cachedModels)) {
            $("#noNotifications-navbar").hide();
        }

        if (this.notificationCount == null)
            this.notificationCount = 0;


        var notificationsCount = this.getNonReadNotificationCountForNavbar();

        const $notificationsCnt = $("#notifications-count");
        if (notificationsCount === 0)
            $notificationsCnt.hide();
        else
            $notificationsCnt.show();
        $notificationsCnt.text(notificationsCount);
        $("#notifications-title").text(i18n.t("notif.new", {count: notificationsCount}));
    }

    getNotificationCount() {
        return super.getNotificationCount({"is_read": false});
    }

    async redrawNotifications(numberOfElements) {
        await super.redrawNotifications(numberOfElements, 10)
    }

    async renderOnDemand(start, visibleElements, upperBound, fromDashboard) {
        await super.renderOnDemand(start, visibleElements, upperBound, fromDashboard, {"is_read": false});
    }

    getNonReadNotificationCountForNavbar() {
        return this.notificationCount > Object.keys(this.cachedModels).length
            ? Object.keys(this.cachedModels).length
            : this.notificationCount;
    }
}

export default NotificationsNavbarView;